import { render } from "./transactions-page.vue?vue&type=template&id=93d6c218&scoped=true&ts=true"
import script from "./transactions-page.vue?vue&type=script&lang=ts"
export * from "./transactions-page.vue?vue&type=script&lang=ts"

import "./transactions-page.vue?vue&type=style&index=0&id=93d6c218&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d6c218"]])

export default __exports__